export default __webpack_public_path__ + "img/cloud-map-ru.34ef4b6.svg";